import { Component, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Exercicio } from '../../../../models/exercicio';
import { ExercicioService } from '../../../../services/exercicio.service';
import { ToastService } from '../../../../services/toast.service';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { DialogService } from '../../../../services/dialog.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ExercicioImagensModalComponent } from '../exercicio-imagens-modal/exercicio-imagens-modal.component';

@Component({
  selector: 'app-admin-exercicio-component',
  templateUrl: './admin-exercicio-component.component.html',
  styleUrls: ['./admin-exercicio-component.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class AdminExercicioComponentComponent implements OnInit {

  form!: FormGroup;
  editando = false;

  dataSource!: MatTableDataSource<Exercicio>;

  filtroTipo: number | null = null; // 🔥 CONTROLA O FILTRO

  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild(MatPaginator) paginator!: MatPaginator;

  displayedColumns: string[] = [
    'id',
    'nome',
    'tipo',
    'actions',
  ];

  constructor(
    private fb: FormBuilder,
    private service: ExercicioService,
    private toastService: ToastService,
    private dialogService: DialogService,
    private modalService: NgbModal
  ) { }

  ngOnInit(): void {
    this.buildForm();
    this.load();
  }

  buildForm() {
    this.form = this.fb.group({
      id: [0],
      nome: [''],
      video: [''],
      comoExecutar: [''],
      tipo: [0]
    });
  }

  load() {
    this.service.getAll().subscribe(res => {

      this.dataSource = new MatTableDataSource(res);

      // 🔥 FILTRO CUSTOMIZADO
      this.dataSource.filterPredicate = (data: Exercicio, filter: string) => {
        if (!filter) return true;

        return data.tipo === Number(filter);
      };

      this.dataSource.sort = this.sort;
      this.dataSource.paginator = this.paginator;

      // 🔥 REAPLICA FILTRO AO CARREGAR
      if (this.filtroTipo) {
        this.dataSource.filter = this.filtroTipo.toString();
      }
    });
  }

  editar(content: Exercicio, id: number) {
    this.editando = true;
    this.form.patchValue(content);

    // 🔥 aplica filtro automaticamente ao editar
    this.filtroTipo = content.tipo;
    this.dataSource.filter = this.filtroTipo.toString();
  }

  novo() {
    this.editando = false;

    // 🔥 LIMPA FILTRO
    this.filtroTipo = null;
    this.dataSource.filter = '';

    this.form.reset({
      id: 0,
      nome: '',
      video: '',
      comoExecutar: '',
      tipo: 0
    });
  }

  salvar() {
    const data = this.form.value as Exercicio;

    if (this.editando) {
      this.service.update(data).subscribe({
        next: () => {
          this.toastService.show('Editado com sucesso', { type: 'success' });
          this.load();
        },
        error: () => {
          this.toastService.show('Erro ao editar!', { type: 'danger' });
        }
      });

    } else {

      this.service.create(data).subscribe({
        next: () => {
          this.toastService.show('Criado com sucesso', { type: 'success' });

          // 🔥 mantém filtro após criação
          this.filtroTipo = data.tipo;

          this.load();
          this.novo();
        },
        error: () => {
          this.toastService.show('Erro ao criar!', { type: 'danger' });
        }
      });

    }
  }

  onTipoChange(event: any) {
    const tipoId = Number(event.target.value);

    this.filtroTipo = tipoId || null;

    this.dataSource.filter = this.filtroTipo
      ? this.filtroTipo.toString()
      : '';
  }

  async remover(id: number) {
    const confirmado = await this.dialogService.confirm('Deseja realmente excluir?', 'Tem certeza?');

    if (confirmado) {
      this.service.delete(id).subscribe({
        next: () => {
          this.toastService.show('Excluído com sucesso', { type: 'success' });
          this.load();
        },
        error: () => {
          this.toastService.show('Erro ao excluir!', { type: 'danger' });
        }
      });
    }
  }

  abrirImagens(exercicioId: number) {
  const modalRef = this.modalService.open(ExercicioImagensModalComponent, {
    size: 'xl',
    centered: true
  });

  modalRef.componentInstance.exercicioId = exercicioId;
}

  tiposExercicio = [
    { id: 1, nome: 'Perna' },
    { id: 2, nome: 'Bíceps' },
    { id: 3, nome: 'Tríceps' },
    { id: 4, nome: 'Peito' },
    { id: 5, nome: 'Costas' },
    { id: 6, nome: 'Ombro' }
  ];
}